export default "__VITE_ASSET__9_np2eeW__"